import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import './styles.css';
import BasicButton from '../../../../components/BasicButton';
import KeyCode from '../../../../constants/keys';

const SubscriptionSearch = ({
  search,
  searchPlaceholder,
  searchQueryMinLength,
  searchQueryMaxLength,
  onSendSearchQueryHandler,
  onDeselectAll,
  onPush,
  counter,
  hasPushButton,
}) => {
  const [query, changeQuery] = useState(search || '');
  const input = useRef();

  useEffect(() => {
    if (search) {
      changeQuery(search);
      input.current.blur();
    } else if (search === '') {
      changeQuery('');
      input.current.blur();
    }
  }, [search]);

  const searchQueryHandler = e => {
    const { value } = e.target;
    if (value.length <= searchQueryMaxLength) {
      changeQuery(value);
    }
  };

  const handleKeyPress = e => {
    if (e.key === KeyCode.ENTER && query.length >= searchQueryMinLength) {
      onSendSearchQueryHandler(query);
    }
  };

  const handleClickButton = e => {
    if (query.length >= searchQueryMinLength) {
      onSendSearchQueryHandler(query);
    }
  };

  return (
    <div className="subscription-search">
      <div className="subscription-search__main">
        <input
          ref={input}
          className="subscription-search__input"
          name="Search"
          type="text"
          value={query}
          onChange={searchQueryHandler}
          placeholder={searchPlaceholder}
          onKeyPress={handleKeyPress}
        />
        <button
          className="subscription-search__btn"
          onClick={handleClickButton}
        />
      </div>
      {hasPushButton && (
        <div className="subscription-search__additional-controls">
          <div>
            <BasicButton
              disabled={!counter}
              btnWidth={130}
              btnHeight={35}
              btnFontSize="0.8571rem"
              btnFontWeight={600}
              btnText="Clear Selection"
              btnArrow={false}
              btnBg="#fff"
              btnHoverBg="#f40"
              controlFunc={onDeselectAll}
            />
          </div>
          <div className="subscription-search__push-btn">
            <BasicButton
              btnWidth={130}
              btnHeight={35}
              btnFontSize="0.8571rem"
              btnFontWeight={600}
              btnText="Push"
              btnArrow={false}
              btnBg="#fff"
              btnHoverBg="#f40"
              controlFunc={onPush}
            />
          </div>
        </div>
      )}
    </div>
  );
};

SubscriptionSearch.defaultProps = {
  searchPlaceholder: 'Search',
  searchQueryMinLength: 0,
  searchQueryMaxLength: 100,
};

SubscriptionSearch.propTypes = {
  search: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  searchQueryMinLength: PropTypes.number,
  searchQueryMaxLength: PropTypes.number,
  searchPlaceholder: PropTypes.string,
  onSendSearchQueryHandler: PropTypes.func.isRequired,
  onDeselectAll: PropTypes.func,
  onPush: PropTypes.func,
  hasPushButton: PropTypes.bool,
  counter: PropTypes.number,
};

export default SubscriptionSearch;
